export let settings = [
  {
    label: "Password Length",
    type: "number",
  },
  {
    label: "Include lowercase letters",
    type: "checkbox",
  },
  {
    label: "Include uppercase letters",
    type: "checkbox",
  },
  {
    label: "Include numbers",
    type: "checkbox",
  },
  {
    label: "Include symbols",
    type: "checkbox",
  },
];
